import React from "react";
import { Footer } from "../components";
import { useProfile } from "../context/ProfilContext";

const FooterWithProfile = () => {
  const { profile } = useProfile();

  const getFooterLinks = () => {
    let extraLink = null;
    const baseLinks = [
      {
        url: "https://www.cncef.org/mentions-legales/",
        title: "Mentions légales",
      },
      {
        url: "https://www.cncef.org/contact/",
        title: "Contact",
      },
    ];

    if (!profile) {
      return baseLinks;
    }
    switch (profile.entity_denomination) {
      case "CNCEF Assurance":
        extraLink = {
          title: "Agréée ACPR",
        };
        break;
      case "CNCEF Crédit":
        extraLink = {
          title: "Agréée  ACPR",
        };
        break;
      case "CNCEF Patrimoine":
        extraLink = {
          title: "AMF",
        };
        break;
    }

    return extraLink ? [extraLink, ...baseLinks] : baseLinks;
  };
  return <Footer links={getFooterLinks()} />;
};
export default FooterWithProfile;
